// WordMatching.js
import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

// Basic styles for the word matching section
const styles = StyleSheet.create({
  container: {
    marginBottom: 12,
  },
  headerRow: {
    flexDirection: "row",
    marginBottom: 8,
    fontSize: 12,
    fontWeight: "bold",
  },
  row: {
    flexDirection: "row",
    marginBottom: 4,
    fontSize: 12,
    lineHeight: 1.4,
  },
  term: {
    width: "30%",
    paddingRight: 4,
  },
  definition: {
    width: "70%",
    paddingLeft: 4,
    wordWrap: "break-word", // Ensures words wrap properly
  overflowWrap: "break-word", // Prevents text overflow
  wordBreak: "keep-all", // Keeps words intact, avoids unnecessary breaking
  hyphens: "none", // Disables hyphenation
  whiteSpace: "normal", // Ensures proper spacing and wrapping
  },
});

// Generate a derangement (a permutation with no fixed points) using Sattolo’s algorithm
function derangedShuffle(array) {
  // For arrays with 0 or 1 element, there is no alternative permutation.
  if (array.length <= 1) return array;

  const newArr = array.slice();
  // Sattolo’s algorithm: i from n-1 downto 1, with j uniformly chosen from 0 to i-1.
  for (let i = newArr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * i); // note: random integer in [0, i)
    [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
  }
  return newArr;
}

export default function WordMatching({ data, typeOfContent }) {
  // Data is assumed to be an array of objects with { word, definition }
  // Create an array of terms (with index for display)
  const terms = data.map((item, index) => ({
    index: index + 1,
    word: item.word,
  }));

  // Conditionally shuffle the definitions only for worksheet,
  // ensuring that no definition remains in its original position.
  const definitions =
    typeOfContent === "worksheet"
      ? derangedShuffle(data.map((item) => item.definition))
      : data.map((item) => item.definition);

  return (
    <View style={styles.container}>
      {/* <Text style={styles.term}>{typeOfContent}</Text> */}
      <View style={styles.headerRow}>
        <Text style={styles.term}>Terms</Text>
        <Text style={styles.definition}>Definitions</Text>
      </View>
      {terms.map((term, i) => (
        <View key={i} style={styles.row}>
          <Text style={styles.term}>
            {term.index}. {term.word}
          </Text>
          <Text style={styles.definition}>{definitions[i]}</Text>
        </View>
      ))}
    </View>
  );
}
